<template lang="html">

  <Modal 
    @close="close"
    :footer="false"
    :closeBtn="false"
    class="error-modal"
  >
    <template #title>Error</template>
    <template #body>
      <div class="flex-column center">
        <!-- <p>There was an error proccessing your request: {{ message }}</p> -->
        <p>{{ message }}</p>

        <router-link 
          :to="'/' + clientAppId + '/support'"
          class="btn grey block"
        > 
          Report an Issue
        </router-link>
        
      </div>
    </template>
  </Modal>

</template>

<script lang="js">

  import { mapState, mapActions } from 'vuex'
  import Modal from '@puzzleapps/shared/src/components/ui/Modal'

  export default  {
    name: 'error-modal',
    
    components: {
      Modal,
    },

    data() {
      return {
      }
    },

    mounted() {
      
    },

    methods: {
      ...mapActions({
        clearError: 'errors/clearError'
      }),

      close() {
        this.clearError()
        this.$emit('close')
      }
    },
    
    computed: {
      ...mapState({
        message: state => state.errors.message,
        clientAppId: state => state.clientAppId,
      }),
    }
  }

</script>

<style scoped lang="scss">
#puzzleapp {
  .error-modal {
    p {
      margin-bottom: 2em;
    }

    .btn {
      width: 100%;
    }
  }
}
</style>